module.exports = __webpack_public_path__ + "static/media/6930.830e72de.jpg";